<template>
  <div class="oct-article-header">
    <h1 class="oct-article-header__primary-text">{{ title }}</h1>
    <p class="oct-article-header__secondary-text" v-if="text !== ''">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: 'OctArticleHeader',
  props: {
    /** Title Text */
    title: {
      type: String,
      default: ''
    },
    /** Text under the title */
    text: {
      type: String,
      default: ''
    },
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-article-header {
  margin: 0 0 oct-rem(72);

  .oct-grid__col &:last-child {
    margin-bottom: oct-rem(72-56);
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  &, .oct-grid__col &:last-child {
    margin-bottom: oct-rem(112);
  }
}
}

.oct-article-header__primary-text {
  font-size: oct-rem(31);
  font-weight: normal;
  line-height: (34/31);
  letter-spacing: -.02em;
  white-space: pre-wrap;
  margin: (-5em/31) 0 ((-5em+12)/31);

  &:last-child {
    margin-bottom: (-5em/31);
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  font-size: oct-rem(58);
  font-weight: normal;
  line-height: (60/58);
  letter-spacing: -.02em;
  white-space: pre-wrap;
  margin: (-8em/58) 0 ((-8em+36)/58);

  &:last-child {
    margin-bottom: (-8em/58);
  }
}
}

.oct-article-header__secondary-text {
  font-size: oct-rem(13);
  font-weight: normal;
  line-height: (17/13);
  letter-spacing: 0;
  margin: (-3em/13) 0;

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  font-size: oct-rem(17);
  font-weight: normal;
  line-height: (24/17);
  letter-spacing: 0;
  margin: (-5em/17) 0;
}
}
</style>
